<template>
  <form class="custom_form">
    <div class="title">實習機構基本資料</div>
    <div id="create_enter_area"></div>
    <div class="btn_area">
      <button v-if="isEdit" class="btn--pill pill blue" @click.prevent="submitData">確定</button>
      <button v-else class="btn--pill pill blue" @click.prevent="submitData">確認送出</button>
    </div>
  </form>
</template>
<script>
import { mapActions } from 'vuex'
import { enter_area } from '~components/common/enter_area.js'
import blueprint from '~components/common/forms/blueprints/EnterpriseInternBasicInfoForm.js'
import '~style/components/enter_area.css'
export default {
  name: 'EnterpriseInternForm',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  mounted () {
    this.togglePageLoader(true);
    let el = $('#create_enter_area')[0];
    this.enterArea = new enter_area(el, this.getBlueprint());
    this.$emit('load', this.enterArea);
  },
  methods: {
    ...mapActions('layouts', [
      'newToast',
      'togglePageLoader',
    ]),
    getBlueprint() {
      if(!this.isEdit) {
        return blueprint.filter(block_data => (
          block_data.key != 'expiry_date' && block_data.key != 'hr_1'
        ));
      }
      return blueprint;
    },
    submitData () {
      if(!this.enterArea) return;
      if(!this.enterArea.valid()) {
        this.newToast({
          variant: 'warning',
          message: '請確認所有欄位是否都有填寫完整'
        });
        return;
      }
      let form_data = this.enterArea.get_form_data();
      form_data.phone = parseInt(form_data.phone);
      delete form_data.expiry_date;
      this.$emit('submit', form_data);
    },
  }
}
</script>


<style lang="scss" scoped>
  .title {
    color: #000000;
    font-size: 19px;
    line-height: 27px;
    font-weight: bold;
    font-family: Noto Sans TC;
    margin-bottom: 26px;

    @media (max-width: 768px) {
      font-size: 14px;
      line-height: 17px;
      margin-bottom: 15px;
    }
  }
  .btn_area {
    margin-top: 18px;
    text-align: right;

    @media (max-width: 768px) { text-align: center; margin-top: 21px; }
  }
</style>